import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import AuthHeader from "@/components/AuthHeader";
import { PrimaryButton } from "@/components/brand";
import api, { formatApiError } from "@/lib/api";
import Footer from "@/components/Footer";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      navigate("/login", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <AuthHeader tag="ACCOUNT RECOVERY" />
      <div className="flex-1 flex items-center">
        <div className="mx-auto w-full max-w-md px-6 py-16">
          <div className="font-mono text-[11px] tracking-[0.18em] uppercase text-gray-400 mb-4">[RESET]</div>
          <h1 className="headline text-5xl text-[#0a0a0a]">Set new password.</h1>
          <form onSubmit={submit} className="mt-10 space-y-6">
            {!token && <div className="border border-orange-500 bg-orange-50 text-orange-700 text-sm px-4 py-3">Missing reset token.</div>}
            {error && <div data-testid="reset-error" className="border border-orange-500 bg-orange-50 text-orange-700 text-sm px-4 py-3">{error}</div>}
            <div>
              <label className="routa-label">New password</label>
              <input data-testid="reset-password-input" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="routa-input" />
            </div>
            <PrimaryButton data-testid="reset-submit-button" type="submit" disabled={busy || !token} className="w-full">
              {busy ? "Updating…" : "Update password"}
            </PrimaryButton>
            <Link to="/login" className="block text-sm text-gray-500 hover:text-[#0a0a0a]">Back to sign in</Link>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}
